export const DASHBOARD_LABELS = {
	ACCESSIBILITY_DASHBOARD_TITLE: 'Accessibility Dashboard',
	ACCESSIBILITY_PERFORMANCE_TRENDS: 'Accessibility performance trends',
	BUSINESS_UNITS: 'Business Units'
};
